import { TagRequest } from '~src/httpClient/TAG/TagRequest';

import { ITagResult } from '../../../../../httpClient/serverApi/types/IResponse';
import { IAnalyticsExtSiteSettings } from '../../../../types/ISiteSettingsForSiteAdmin';

export type IUpdateAnalyticsExtSiteSettingsResult = ITagResult & IAnalyticsExtSiteSettings;

export class UpdateAnalyticsExtSiteSettingsRequest extends TagRequest<IAnalyticsExtSiteSettings, IUpdateAnalyticsExtSiteSettingsResult> {
  constructor(params: IAnalyticsExtSiteSettings) {
    super('analyticsextensions', 'updateAnalyticsExtensionsSiteSettings', params);
  }
}
